import React, { useState } from 'react'
import SearchIcon from '@mui/icons-material/Search'
import DragIndicatorIcon from '@mui/icons-material/DragIndicator'
import Modal from './modal'
import { useTranslation } from '../../i18n/I18nProvider'

const ManageColumns = (props) => {
  const { translations } = useTranslation()
  const cs = translations.common || {}
  const { headers, onSave, updateModal, headTxt = "Manage Columns" } = props

  const [columns, setColumns] = useState([...headers])
  const [searchValue, setSearchValue] = useState('')

  const dragItem = React.useRef(null)

  const handleSort = () => {
    let updatedColumns = [...columns]
    const draggedItemContent = updatedColumns.splice(dragItem.current, 1)[0]
    updatedColumns.splice(dragItem.current, 0, draggedItemContent)
    setColumns(updatedColumns)
    dragItem.current = null
  }

  const handleChange = (e, val) => {
    const updatedColumns = columns.map((item) => (item.id === val.id ? { ...item, isSelected: e.target.checked } : item))
    setColumns(updatedColumns)
  }

  const handleReset = () => {
    const updatedColumns = columns.map((item) =>
      item.isSelected && !item.isDefault && !item.isMandatory ? { ...item, isSelected: false } : item
    )
    setColumns(updatedColumns)
  }

  return (
    <Modal className="manageColumns " headTxt={headTxt} width={'26%'} height={'80%'} updateModal={updateModal}>
      <div className="job-card-modal ">
        <div className="drop--wrapper">
          <input type="text" placeholder="Search" value={searchValue} onChange={(e) => setSearchValue(e.target.value)} />
          <div className="search--icon">
            <SearchIcon style={{ color: '#ccc' }} />
          </div>
        </div>
        <div className="status-container scrollBlue">
          {columns
            .filter((item) => item.header?.toLowerCase().includes(searchValue.toLowerCase()))
            .map((val, i) => (
              val?.isHeader ?
                <div className="status-row" style={{ background: '#F2F9FF', display: 'flex', justifyContent: 'center' }} key={i}>
                  <span style={{ fontSize: '14px', fontWeight: '600',color:'#444' }}>
                    {val.header}
                  </span>
                </div>
                :
                <div className="status-row" style={{ background: val.isMandatory ? '#eee' : '' }} key={i}>
                  <div
                    className="status-name"
                    draggable
                    onDragStart={() => (dragItem.current = i)}
                    onDragEnd={handleSort}
                    onDragOver={(e) => e.preventDefault()}
                  >
                    <DragIndicatorIcon style={{ color: '#777' }} />
                    {val.header}
                  </div>
                  <input type="checkbox" checked={val.isSelected} disabled={val.isMandatory} onChange={(e) => handleChange(e, val)} />
                </div>
            ))}
        </div>
        <div className="jobCard-button">
          <div key="itrl_xls_btn" className="dashed--btn" style={{textTransform:'uppercase'}} onClick={() => updateModal(false)} tabIndex={0}>
            {cs.cancel}
          </div>
          <div key="itrl_prn_btn" className="dashed--btn" style={{textTransform:'uppercase'}} onClick={handleReset} tabIndex={0}>
            {cs.reset}
          </div>
          <div
            className="search--btn"
            style={{textTransform:'uppercase'}}
            onClick={() => {
              updateModal(false)
              onSave(columns)
            }}
            tabIndex={0}
          >
            {cs.save}
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default ManageColumns
